import { QuizyUrl, MTempUrl,EditMaterialUrl, GenMaterialUrl } from "../../libs/env";
import React, { useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import PrintScreenButton from "../../components/buttons/PrintButton";
import { MaterialHeader } from "./MaterialHeader";
import MaterialContent from "./MaterialContent";
import { Row } from "reactstrap";
import { useLocation } from "react-router-dom";


const MaterialRunner = ({
  isLoaded,
  data,
  display,
  UpdateMaterial,
}) => {
  const {pathname} = useLocation()
  let container = "";
  let wraperbackground = "bg-none";
  let padding = "g-0 px-2";
  let quizbackground = "bg-quiz-content";
  let margin0="footer-sticky g-0";
  let spinner_color = "text-light";
  let Quizyheight="pb-4";
  let question_scroll = "question_scroll";
  let fsize="fs-14";


if (pathname.includes(EditMaterialUrl) || pathname.includes(GenMaterialUrl)) {
    container = "";
    question_scroll = "question_scroll";
    padding = "g-0 px-5";
    quizbackground = "px-0 pe-3";
    Quizyheight="py-4 min-h-84 quiz-detail-width";
}
else if (pathname.includes(MTempUrl)){
    container = "";
    padding = "g-0 px-5";
    quizbackground = "px-0";
    spinner_color = "text-white";
    Quizyheight = "pt-3 pb-5";
}
else if (window.location.origin.includes(QuizyUrl)) {
  container = "";
  question_scroll = "question_scroll";
  padding = "g-0 px-5";
  quizbackground = "px-0 pe-3";
  Quizyheight="min-h-84 pb-4";
}

  const contentRef = useRef();
  const handleScroll = (e) => {
    var timer;
    const container = e.target ;
    if (container)
    {
      container.classList.add('scrollable_scroll');
      clearTimeout(timer);
      timer = setTimeout(() => {
        container.classList.remove('scrollable_scroll');
      }, 1000);
    }
  };

  if (!isLoaded)
    return (
      <div className={`centered ${spinner_color} fs-4`}>
        <div class="spinner-border h-w-100" role="status"></div>
      </div>
    );
  return (
    <div className={`dashboard-wrapper ${wraperbackground}`}>
      <div class={`${container}`}>
        <div className={` row ${padding}`}>
        <div className={`sm-py-1 ${quizbackground}`}>
            <div ref={contentRef}>
                <div className={`quiz-detail ${Quizyheight}`}>
                    <div id="scroll" onScroll={handleScroll} className={`${question_scroll}`}>
                        <div className="Question__description">
                            <MaterialHeader
                                data={data}
                                display={display}
                            />
                            <Row className={`border bg-white border-top-0 border-bottom-0 px-4 py-3 ${fsize}`}>
                            <MaterialContent
                                data={data}
                                UpdateMaterial={UpdateMaterial}
                            />
                            </Row>
                        </div>
                    </div>
                    <Row id="footer" className={`pt-4 ${margin0}`}>
                        <div className="no-download">
                          <Row>
                              <div className="col-12 d-inline-flex  d-flex justify-content-end">
                                <PrintScreenButton px_class={"px-4"} downloadUrl={`/pdf/download/material/${data.id}`} />
                              </div>
                          </Row>
                        </div>
                    </Row>
                </div>
            </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialRunner;
